// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  googleClientId: '219886304444-7kjn0htm1mvieg2k5hpclkhg0g2c6jg2.apps.googleusercontent.com',

 
  websiteUrl: 'https://codingcafetest-stg.bridgelabz.com',
  // websiteUrl: 'http://localhost:4201'

  adminUrl: 'https://ccadmin.incubation.bridgelabz.com',
  // adminUrl:'http://192.168.0.19:8080',
  //adminUrl: 'http://192.168.0.143:8083',

  baseUrl: 'https://ccmcqsettings.incubation.bridgelabz.com/mcqsettings',
  //baseUrl:  'http://192.168.0.143:8089/mcqsettings',

  driveDashboardUrl : 'https://ccdrivedash.incubation.bridgelabz.com',
 //  driveDashboardUrl : 'http://192.168.0.143:8088',

  campaignDashboardUrl: 'https://cccampdash.incubation.bridgelabz.com',
 //campaignDashboardUrl:'http://192.168.0.143:8087',

  driveUrl: 'https://ccdrivedash.incubation.bridgelabz.com', // 'http://192.168.0.161:8080',
  // driveUrl: 'http://192.168.0.19:8088',

 userServiceUrl: 'https://ccuser.incubation.bridgelabz.com',
  // userServiceUrl: 'https://192.168.0.143:8085 ',

  //campaignUrl: 'https://ccfea.incubation.bridgelabz.com/register/',
 campaignUrl1: 'http://codingcafetest-stg.bridgelabz.com/',
  //campaignUrl1:'https://www-dev.incubation.bridgelabz.com/codingtest/',
  codinClubUrl:'https://www-dev.incubation.bridgelabz.com/codingtest/',
  // campaignUrl: 'http://localhost:4200/register/',

  attendanceUrl: 'https://ccfea.incubation.bridgelabz.com/attendance/',
  // campaignDashboardUrl:'http://192.168.0.61:8087',

  facebookUrl: 'https://www.facebook.com/bridgelabz/',


  // SMSUrl: 'http://192.168.0.128:8089/mcqsettings'


};


/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
